module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/vectors/term-bg-4-42055356b1beb1cd323b9b1e0a85e866.jpg";